module.exports = __webpack_public_path__ + "img/DashboardActionCard.0ffef7df.jpg";